import React, { useEffect } from 'react';
import { Pagination, PaginationItem } from '@material-ui/lab';
import { Link, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { getEvents } from '../../actions/events';
import { buildThemeHref, readDiscoveryTheme } from '../../lib/discoveryThemes';
import useStyles from '../styles';

const EventsPagination = ({ page }) => {
    const { numberOfPages } = useSelector((state) => state.events);
    const classes = useStyles();
    const dispatch = useDispatch();
    const location = useLocation();
    const activeTheme = readDiscoveryTheme(location.search);
        
    useEffect(() => {
        if(page) dispatch(getEvents(page));
    }, [page, dispatch]);

    return (
        <Pagination 
            classes={{ ul: classes.ul }}
            count={numberOfPages}
            page={Number(page) || 1}
            variant="outlined"
            color="primary"
            renderItem={(item) => (
                <PaginationItem
                    { ...item }
                    component={Link}
                    to={buildThemeHref('/events', location.search, activeTheme, { page: item.page })}
                />
            )}
        />
    );
};

export default EventsPagination;
